import ical from 'ical-generator'
import { DateTime } from 'luxon'
import { Plan } from 'src/generated/brezavta/requests'
import { getEmojiForMode } from './modes'
import { downloadStringAsFile } from './util'

export function planToIcal(plan: Plan): string {
    const calendar = ical({
        prodId: '-//brezavta.si',
    })

    let i = 0
    for (const leg of plan.legs) {
        const startTime = DateTime.fromMillis(leg.start_time, { zone: 'Europe/Ljubljana' })
        const endTime = DateTime.fromMillis(leg.end_time, { zone: 'Europe/Ljubljana' })

        // Remove walk legs except the first and last one
        if (leg.mode === 'WALK' && !(i++ === 0 || i === plan.legs.length))
            continue

        calendar.createEvent({
            start: startTime,
            end: endTime,
            summary: `${getEmojiForMode(leg.mode)} ${leg.trip?.long_name || leg.trip?.short_name || leg.trip?.headsign || ''}`,
            url: window.location.href,
        })
    }

    return calendar.toString()
}

export function addToCalendar(ics: string) {
    // TODO: better implementation of addToCalendar for mobile platforms
    // Default implementation
    downloadStringAsFile(ics, 'text/calendar', 'brezavta.ics')
}
